module.exports = __webpack_public_path__ + "static/img/default-avatar.b47dba7a.png";